
import Vue from 'vue';
import store from '../store'

export default async function SubscriptionMiddleware(to, from, next)  {

  if (store.getters['auth/isSubscriptionExpired']) {
    next('/assinatura-expirada')
  }

  next()
  
}